import { render, staticRenderFns } from "./OrdersFilter.vue?vue&type=template&id=7b37f562&scoped=true"
import script from "./OrdersFilter.vue?vue&type=script&lang=js"
export * from "./OrdersFilter.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b37f562",
  null
  
)

export default component.exports